import { ElementTracker, ElementTrackerType } from '@enaratech/funnel-helper';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { useRoutePath } from 'src/hooks/useRoutePath';
import TermsOfUse from '../TermsOfUse/TermsOfUse';

type Props = {
  onChangeConsent: (granted: boolean) => void;
};

const AutomatedTextMessagesNotice: FC<Props> = ({ onChangeConsent }) => {
  const routePath = useRoutePath();

  return (
    <Box my={2}>
      <FormControlLabel
        control={
          <ElementTracker
            routePath={routePath}
            name={'Automated Text Messages Notice'}
            type={ElementTrackerType.Checkable}>
            <Checkbox
              onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
                onChangeConsent(target.checked)
              }
            />
          </ElementTracker>
        }
        label={
          <TermsOfUse
            alternativeNotice={
              'Yes, I agree to receive recurring automated text messages from Enara Health regarding appointment reminders, general health notifications and marketing purposes at the mobile number provided. Message frequency may vary. Message and data rates may apply. Reply HELP for help, STOP to cancel. View our '
            }
            alternativeFooter={' for more details.'}
          />
        }
      />
    </Box>
  );
};

export default AutomatedTextMessagesNotice;
